import { render } from "./indexPaymentMethodsComponent.vue?vue&type=template&id=e07076c4"
import script from "./indexPaymentMethodsComponent.vue?vue&type=script&lang=js"
export * from "./indexPaymentMethodsComponent.vue?vue&type=script&lang=js"

import "./indexPaymentMethodsComponent.vue?vue&type=style&index=0&id=e07076c4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__